import { observer } from 'mobx-react-lite';
import { Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import styles from './index.module.scss';
import { eventNameOptions } from '../events-fields-options';
import classNames from 'classnames';
import EventContent from './EventContent';
import { IClinicalVersion } from '../types';
import { formatTime } from '../../../../services/timeService';
import { dateTimeFormat } from '../../../../services/timeService/types';

const EventVersion = ({
  version,
  eventTime,
  timezone,
}: {
  version?: IClinicalVersion;
  eventTime?: string;
  timezone?: string;
}) => {
  const name = eventNameOptions?.find((option) => option.value === version?.eventName)?.label;
  return (
    <div className={styles.eventVersion}>
      <Accordion className={styles.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={styles.summary}
          classes={{
            content: 'flex-col items-start m-0',
            expanded: styles.expanded,
          }}
        >
          <div className={'text-sm text-neutrals-n-300'}>{name}</div>
          <div className={classNames('text-neutrals-n-300', styles.createdAt)}>
            Version created at ·{' '}
            {formatTime(version?.timestamp, dateTimeFormat.DATE_TIME_FORMAT, timezone)}
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Divider className={'mb-4'} />
          <EventContent version={version} eventTime={eventTime} timezone={timezone} />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default observer(EventVersion);
